module.exports = __webpack_public_path__ + "static/media/logs.29858290.svg";